import { render, staticRenderFns } from "./AudioFileForm.vue?vue&type=template&id=85faab46&"
import script from "./AudioFileForm.vue?vue&type=script&lang=js&"
export * from "./AudioFileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports